import React, { useRef } from "react";
import PropTypes from "prop-types";
import Logo from "../../assets/svg/AanrudixLogoBlackText.png";
import convert from "number-to-words";
import { Button } from "antd";
import moment from "moment";
import { useSelector } from "react-redux";
import { convertCurrency } from "../../utils/helpers";
import html2pdf from "html2pdf.js";

const HorizontalView = ({ items }) => {
  return (
    Array.isArray(items) &&
    items.map(({ label, value }, idx) => {
      return (
        <div key={idx} className="flex mb-2 text-xs justify-between">
          <span className="font-medium flex gap-2">
            {label} <span>:</span>
          </span>
          <span>{value}</span>
        </div>
      );
    })
  );
};

const TableRow = ({ items, date }) => {
  return (
    Array.isArray(items) &&
    items.map(
      (
        {
          earningParticulars,
          earningActual,
          earningYtd,
          deductionParticulars,
          deductionActual,
          deductionYtd,
          style,
        },
        idx
      ) => {
        return (
          <tr key={idx} className={style?.rowClass ? style.rowClass : ""}>
            <td className="border border-gray-500 px-2">
              {earningParticulars}
            </td>
            <td className="border border-gray-500 px-2" align="right">
              {convertCurrency(earningActual)}
            </td>
            <td className="border border-gray-500 px-2" align="right">
              {earningYtd
                ? convertCurrency(earningYtd * (moment(date).month() + 1))
                : null}
            </td>
            <td className="border border-gray-500 px-2">
              {deductionParticulars}
            </td>
            <td className="border border-gray-500 px-2" align="right">
              {deductionActual ? convertCurrency(deductionActual) : null}
            </td>
            <td className="border border-gray-500 px-2" align="right">
              {deductionYtd
                ? convertCurrency(deductionYtd * (moment(date).month() + 1))
                : null}
            </td>
          </tr>
        );
      }
    )
  );
};

const SalarySlip = ({ data, onClose }) => {
  const componentRef = useRef();
  const user = useSelector((state) => state.application.user);
  const meta = user?.meta;

  const handleDownloadPdf = async () => {
    const element = componentRef.current;
    const opt = {
      filename: `salary slip ${data?.month}-${data?.year}.pdf`,
    };
    html2pdf().set(opt).from(element).save();
  };
  return (
    <div className="flex flex-col items-center">
      <section
        ref={componentRef}
        id="salarySlip"
        className="p-4 bg-white"
        style={{ width: "794px", fontSize: "14px" }}
      >
        <header className="flex flex-col items-center gap-4 mb-4">
          <img src={Logo} alt="logo" width={200} />
          <div className="uppercase text-center">
            <h1 className="text-lg font-medium">AANRUDIX PRIVATE LIMITED</h1>
            <p>
              PAYSLIP FOR THE MONTH{" "}
              {moment(data?.paymentDate).format("MMMM-YYYY")}
            </p>
          </div>
        </header>
        <div className="px-4  py-2 bg-gray-200 border border-gray-500 flex gap-3 font-medium mb-4">
          <div>
            <p>Name</p>
            <p>Designation</p>
          </div>
          <div>
            <p>
              : {user?.firstName} {user?.lastName}
            </p>
            <p>: {user?.roleDetail?.label}</p>
          </div>
        </div>
        <table className="w-full mb-4 border border-gray-500">
          <tr>
            <td className="border border-gray-500 p-4">
              <HorizontalView
                items={[
                  { label: "Employee ID", value: meta?.empId },
                  { label: "Department", value: meta?.department },
                  {
                    label: "Bank A/C No",
                    value: meta?.bankAccountNumber,
                  },
                  { label: "UAN No", value: meta?.uanNumber },
                  { label: "Location", value: meta?.city },
                ]}
              />
            </td>
            <td className="border border-gray-500 p-4">
              <HorizontalView
                items={[
                  { label: "Date of Joining", value: meta?.joiningDate },
                  { label: "PAN No", value: meta?.panNumber },
                  { label: "Bank Name", value: meta?.bankName },
                  { label: "ESI No", value: meta?.esiNumber },
                  { label: "Aadhaar no", value: meta?.aadhaarNumber },
                ]}
              />
            </td>
            {/* <td className="p-4 grid grid-cols-3 gap-2 text-xs">
              <p className="text-center font-medium">
                No.of unpaid <br /> leaves
              </p>
              <p className="text-center font-medium">
                No.of Extra days <br /> paid
              </p>
              <p className="text-center font-medium">
                No.of days <br /> paid
              </p>
              <p className="text-center">-</p>
              <p className="text-center">-</p>
              <p className="text-center">-</p>
            </td> */}
          </tr>
        </table>
        <table className="w-full mb-4 border border-gray-500">
          <tr className="bg-gray-300">
            <th className="border border-gray-500 py-2" colSpan={3}>
              Earnings
            </th>
            <th className="border border-gray-500 py-2" colSpan={3}>
              Deductions
            </th>
          </tr>
          <tr className="bg-gray-100">
            <th className="border border-gray-500">Particulars</th>
            <th className="border border-gray-500">Actual Earnings</th>
            <th className="border border-gray-500">YTD</th>
            <th className="border border-gray-500">Particulars</th>
            <th className="border border-gray-500">Amount</th>
            <th className="border border-gray-500">YTD</th>
          </tr>
          <TableRow
            items={[
              {
                earningParticulars: "Basic",
                earningActual: data?.basicPay,
                earningYtd: data?.basicPay,
                deductionParticulars: "Income Tax",
                deductionActual: data?.incomeTax,
                deductionYtd: data?.incomeTax,
              },
              {
                earningParticulars: "House Rent Allowance",
                earningActual: data?.hra,
                earningYtd: data?.hra,
                deductionParticulars: "Professional Tax",
                deductionActual: data?.professionalTax,
                deductionYtd: data?.professionalTax,
              },
              {
                earningParticulars: "Medical Allowance",
                earningActual: data?.medicalAllowance,
                earningYtd: data?.medicalAllowance,
                deductionParticulars: "PF",
                deductionActual: data?.pf,
                deductionYtd: data?.pf,
              },
              {
                earningParticulars: "Conveyance Allowance ",
                earningActual: data?.conveyance,
                earningYtd: data?.conveyance,
                deductionParticulars: "",
                deductionActual: "",
                deductionYtd: "",
              },
              {
                earningParticulars: "Total Earnings",
                earningActual: data?.grossSalary,
                earningYtd: data?.grossSalary,
                deductionParticulars: "Gross Deductions",
                deductionActual: data?.totalDeductions,
                deductionYtd: data?.totalDeductions,
                style: { rowClass: "font-bold" },
              },
            ]}
            date={data?.paymentDate}
          />
          <tr>
            <th colSpan={6} className="border border-gray-500 px-2 py-1">
              Net pay for the month (Rs): {convertCurrency(data?.netSalary)} (
              <span className="capitalize">
                {convert.toWords(data?.netSalary)} Rupees
              </span>
              )
            </th>
          </tr>
        </table>
        <div className="flex flex-col gap-2 font-medium">
          <p>
            <span className="font-bold">Tax Regime used :</span> New Regime
          </p>
          <p>
            ** Note: This is a System generated Payslip, hence does not require
            any Signature **
          </p>
          <p>** All Figures mentioned are in INR **</p>
        </div>
      </section>
      <footer className="flex justify-end gap-4 px-2 w-full">
        <Button onClick={onClose}>Close</Button>
        <Button
          type="primary"
          onClick={handleDownloadPdf}
          className="bg-blue-600"
        >
          Download
        </Button>
      </footer>
    </div>
  );
};

SalarySlip.propTypes = {
  data: PropTypes.any,
  onClose: PropTypes.func,
};

export default SalarySlip;
